export enum sortFieldJobVacanciesEnum {
  JOBNAME = 'name',
  CATEGORY = 'category',
  LOCATION = 'location',
  CREATEDATUTC0 = 'createdAt',
}

export enum sortFieldJobApplicantsEnum {
  DEFAULT = '',
  NAME = 'name',
  GENDER = 'gender',
  PHONENO = 'phoneNo',
  ADDRESS = 'address',
  JOBEXPERIENCE = 'jobExperience',
}

export enum categoryJobVacanciesEnum {
  DEFAULT = '',
  HARVESTER = 'HARVESTER',
  UPKEEPER = 'UPKEEPER',
  SHIPPER = 'SHIPPER',
}

export enum wageUnitJobVacancyEnum {
  DEFAULT = '',
  TON = 'Ton',
  KG = 'Kg',
  HA = 'Ha',
  BORONGAN = 'Borongan',
  JANJANG = 'Janjang',
}

export enum facilitiesEnum {
  TEMPATTINGGAL = 'Tempat Tinggal',
  MAKANPAGI = 'Makan Pagi',
  MAKANSIANG = 'Makan Siang',
  MAKANMALAM = 'Makan Malam',
  PERALATANKERJA = 'Peralatan Kerja',
  UANGSAKU = 'Uang Saku',
  TINGGALSENDIRI = 'Tinggal sendiri',
  DISEDIAKANKENDARAAN = 'Disediakan Kendaraan',
  TUNAI = 'Tunai',
  TRANSFERBANK = 'Transfer ke Bank',
}

export enum soiltTypeEnum {
  GAMBUT = 'Tanah Gambut',
  MINERAL = 'Tanah Mineral',
  SULFATMASAM = 'Tanah Sulfat Masam',
  BERPASIR = 'Tanah Berpasir',
}

export enum collectionMethodEnum {
  DIPIKUL = 'Dipikul',
  KERETASORONG = 'Kereta Sorong',
}
